import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';

import { appPaths } from '~/routes/app-paths';

import * as S from './Footer.styles';

export interface FooterProps {
  hasScroll: boolean;
  onClose: () => void;
}

export const Footer = ({ hasScroll, onClose }: FooterProps) => {
  const { t } = useTranslation('alerts');
  const navigate = useNavigate();

  const handleNavigateToAlerts = () => {
    onClose();
    navigate(appPaths.alerts);
  };

  return (
    <S.FooterRoot $hasScroll={hasScroll}>
      <S.FooterText>{t('dropdown.footerText')}</S.FooterText>
      <S.StyledButtonLink
        label={t('dropdown.viewPastNotifications')}
        onClick={handleNavigateToAlerts}
      />
    </S.FooterRoot>
  );
};
